module.exports = __webpack_public_path__ + "img/header_bg.56ae2edf.png";